import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import GiftCards from "@/components/GiftCards";
import StudioCircle from "@/components/StudioCircle";
import Newsletter from "@/components/Newsletter";
import FAQ, { HOME_FAQS } from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import MakeupWaitlist from "@/components/MakeupWaitlist";
import { applySeo, buildFaqSchema } from "@/lib/seo";

export default function Home() {
  useEffect(() => {
    applySeo({
      title: "Sacramento Esthetician | Beauty & Balance by Bella — Massage & Custom Facials",
      description:
        "Beauty & Balance by Bella is a licensed Sacramento esthetician studio offering therapeutic massage and custom facials by appointment. Downtown Sacramento, CA.",
      path: "/",
      type: "website",
      jsonLd: buildFaqSchema(HOME_FAQS),
    });
  }, []);

  return (
    <main data-testid="home-page" className="relative">
      <Navigation />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <Testimonials />
      <GiftCards />
      <StudioCircle />
      <MakeupWaitlist />
      <Newsletter />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
